import { JSONTree } from "react-json-tree"
import { NumericFormat } from "react-number-format"
interface PayTile{
    payAmt?:number,
    title?:string
    lookBackPeriodSatisfied?:boolean
}
export const PayTile = ({payAmt: netPayAmt=0,title='Monthly Net Pay',lookBackPeriodSatisfied=true}:PayTile) => {
    return <>
        <div className={`block`}>
            <div style={{fontSize:'12px',lineHeight:'16px',textAlign:'center'}}>{!lookBackPeriodSatisfied && 'Est.'} {title}</div>
            <br />
            <span
                style={{
                    fontSize: "12px",
                    lineHeight: "16px",
                    textAlign: "center",
                    paddingTop: "4px",
                }}
            >
                <NumericFormat
                    thousandSeparator={","}
                    style={{ fontSize: 12 }}
                    prefix={"$"}
                    decimalScale={2}
                    displayType={"text"}
                    value={isNaN(netPayAmt) ? 0 : netPayAmt}
                    fixedDecimalScale={true}
                />
            </span>
        </div>
    </>
}